import {useQuery} from "@tanstack/react-query";
import React, {useMemo, useState} from "react";
import Statement from "../../components/Statements/Statement.tsx";
import {SentimentVeryDissatisfied} from "@mui/icons-material";
import {Container, Typography} from "@mui/material";
import {CardGrid} from "@laser-project/kyui";
import {ICalibration} from "../../types/models/Calibration.ts";
import CalibrationRest from "../../rest/CalibrationRest.ts";
import CalibrationWebsocket from "../../websocket/CalibrationWebsocket.ts";
import {useWebsocketHandler} from "../../components/WebsocketHandler/useWebsocketHandler.tsx";
import {useNavigate} from "react-router-dom";
import JobRest from "../../rest/JobRest.ts";
import {IPopulatedJob} from "../../types/FrontendTypes.ts";
import Boxel from "../../components/Icons/Boxel.tsx";
import {CalibrationCard} from "../../components/Calibrations/CalibrationCard.tsx";

export function CalibrationOverviewPage() {
    const navigate = useNavigate();

    const calibrationRest = useMemo(() => new CalibrationRest(), []);
    const calibrationWebsocket = useMemo(() => new CalibrationWebsocket(), []);
    const jobRest = useMemo(() => new JobRest(), []);

    const [limit, setLimit] = useState(20);


    const {isPending, error, data, refetch} = useQuery({
        queryKey: ['calibrations', limit],
        queryFn: () =>
            //calibrationRest.get().then(res => res.data as { data: ICalibration[] })
            calibrationRest.get_calibrations_paged(limit).then(res => res.data as { data: ICalibration[] }),
    })

    useWebsocketHandler({webSocketUrl: calibrationWebsocket.getAllUpdates(), refetch: refetch});

    if (error) {
        return <Statement message={error.message} icon={<SentimentVeryDissatisfied/>}/>
    }

    function generateCards() {

        if (!data) {
            return
        }

        const CalibrationOverviewCard = ({ calibration }: { calibration: ICalibration }) => {

            const job = useQuery({
                    queryKey: ['jobs', calibration.jobId ?? null],
                    queryFn: () =>
                        calibration.jobId ? jobRest.getById(calibration.jobId).then(res =>
                            res.data.data as IPopulatedJob) : null,
            });

            return <CalibrationCard
                calibration={calibration}
                job={job}
                onclick={() => navigate("/calibrations/" + calibration._id)}
                jobRest={jobRest}
            />
        };

        const calibrationCards = ({ data }: { data: ICalibration[] }) => {
            console.log(data)
            return (
                data.map((calibration) => (
                    <CalibrationOverviewCard key={calibration._id} calibration={calibration} />
                ))
            );
        };

        return calibrationCards(data)
    }

    return (<Container sx={{p: 4}}>
        <Typography variant={"h3"} sx={{mb: 4}}>Calibrations</Typography>
        <CardGrid
            behaviour={"responsive"}
            isLoading={isPending}
            renderEmptyGrid={() => <Statement message={"No calibrations found"} icon={<Boxel/>}/>}
            onClickNextPage={() => setLimit(limit + 20)}
            cards={generateCards()}
        />
    </Container>)

}

export default CalibrationOverviewPage